module.exports = __webpack_public_path__ + "img/maths.931c8ab6.png";